export default __webpack_public_path__ + "static/media/voicegot-screenshot-01.6a554bec.png";